var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"eventCardList"}},_vm._l((_vm.Events),function(event,index){return _c('EventCard',_vm._g({key:index,attrs:{"Event":event}},_vm.$listeners))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }